export const ENTRY_TYPE = {
  NATURAL_PERSON: 1,
  LEGAL_ENTITY: 2,
};


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/constants/watchListEntryConstants.js